import  { useEffect, useState } from 'react';

const useAdmin = user => {
 

    const userEmail = user?.email;
    const [admin, setAdmin] = useState(false);   

    useEffect(() => {
        fetch(`https://stark-wildwood-35883.herokuapp.com/admin/${userEmail}`)
            .then(res => res.json())
            .then(data =>{
                const status = data?.admin;
                setAdmin(status);
            })
            
    }, [user, userEmail])

     

    return [admin, setAdmin];
};

export default useAdmin;